<template>
  <div v-loading="isLoading" class="container bg-white mt-1 mx-auto p-10 fs-16">
    <div class="flex justify-start">
      <div class="flex gap-4 items-center">
        <svg
          @click="goToCircleDetail"
          class="cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.41406 12.657L12.3641 16.607C12.5417 16.7964 12.6387 17.0475 12.6345 17.3072C12.6303 17.5669 12.5252 17.8148 12.3415 17.9983C12.1578 18.1819 11.9098 18.2868 11.6501 18.2909C11.3905 18.2949 11.1394 18.1977 10.9501 18.02L5.29306 12.364C5.19987 12.2713 5.12592 12.1611 5.07546 12.0398C5.025 11.9185 4.99902 11.7884 4.99902 11.657C4.99902 11.5256 5.025 11.3954 5.07546 11.2741C5.12592 11.1528 5.19987 11.0426 5.29306 10.95L10.9501 5.29296C11.0423 5.19745 11.1526 5.12127 11.2747 5.06886C11.3967 5.01645 11.5279 4.98886 11.6607 4.98771C11.7934 4.98655 11.9251 5.01186 12.048 5.06214C12.1709 5.11242 12.2826 5.18667 12.3765 5.28056C12.4703 5.37446 12.5446 5.48611 12.5949 5.60901C12.6452 5.7319 12.6705 5.86358 12.6693 5.99636C12.6682 6.12914 12.6406 6.26036 12.5882 6.38236C12.5358 6.50437 12.4596 6.61471 12.3641 6.70696L8.41406 10.657H18.0001C18.2653 10.657 18.5196 10.7623 18.7072 10.9499C18.8947 11.1374 19.0001 11.3917 19.0001 11.657C19.0001 11.9222 18.8947 12.1765 18.7072 12.3641C18.5196 12.5516 18.2653 12.657 18.0001 12.657H8.41406Z"
            fill="black"
          />
        </svg>
        <span class="font-bold fs-26">{{ getHeader() }}</span>
      </div>
    </div>
    <div class="mt-4">
      <div class="w-full flex flex-col lg:flex-row justify-between gap-4 lg:gap-2">
        <div class="flex-1 flex flex-col gap-2">
          <div class="flex flex-col gap-2">
            <p class="fs-24 fw-600 max-line-2 txt-pri title mb-0 labels">
              <span
                class="fs-14 text-white"
                :class="getStatus(sessionData.status).class"
              >{{ getStatus(sessionData.status).text }}</span>
            </p>
            <div style="color:#20409b" class="flex-1 fs-20 font-bold">{{getDataLang().title||'' }}</div>
          </div>
          <div
            v-if="sessionData.circle_schedule_speakers && sessionData.circle_schedule_speakers.length"
            class="flex flex-col gap-2 mb-2"
          >
            <span>{{ $t('conference.lbl_speaker') }}:</span>
            <div class="flex gap-3">
              <div v-for="speaker in sessionData.circle_schedule_speakers" :key="speaker.id">
                <div
                  v-if="speaker.user_speaker"
                  class="flex gap-1 items-center cursor-pointer"
                  @click="goToProfile(speaker.user_speaker)"
                >
                  <div :set="speakerInfo=speaker.user_speaker" style="max-width: 32px">
                    <!-- <span
                      v-if="speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded"
                      :style="
                          'background-image: url(' +
                          getImageURL(speakerInfo.avatar) +
                          ')'
                        "
                    ></span>-->
                    <!-- <span
                      v-if="speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded bg-top"
                      :style="
                          'background-image: url(' +
                          getImageURL(speakerInfo.avatar) +
                          ')'
                        "
                    ></span>-->
                    <ImageBox
                      v-if="speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded object-cover object-top border"
                      avatar
                      :source="getImageURL(speakerInfo.avatar)"
                      :alt="getMultilangValue(speakerInfo.speaker_multi_language).name || speakerInfo.name"
                    />
                    <span
                      v-if="!speakerInfo||!speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded bg-pri text-white"
                    >
                      {{
                      speakerInfo.name.charAt(0) ||
                      speakerInfo.email.charAt(0)
                      }}
                    </span>
                  </div>
                  <span
                    class="font-bold"
                  >{{ getMultilangValue(speakerInfo.speaker_multi_language).name || speakerInfo.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-4">
            <div class="flex gap-2 items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 5.5H6.5V3.5C6.5 3.36739 6.44732 3.24021 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24021 5.5 3.36739 5.5 3.5V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5H7.5C7.63261 6.5 7.75979 6.44732 7.85356 6.35355C7.94732 6.25979 8 6.13261 8 6C8 5.86739 7.94732 5.74021 7.85356 5.64645C7.75979 5.55268 7.63261 5.5 7.5 5.5ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61216 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ $t('conference.fm_minutes',{minutes:sessionData.duration}) }}</span>
            </div>
            <div class="flex gap-2 items-center">
              <svg
                class="mb-1"
                width="16"
                height="16"
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 9.5C5.09889 9.5 5.19556 9.47068 5.27779 9.41574C5.36001 9.36079 5.4241 9.2827 5.46194 9.19134C5.49978 9.09998 5.50969 8.99944 5.49039 8.90245C5.4711 8.80546 5.42348 8.71637 5.35355 8.64645C5.28363 8.57652 5.19454 8.5289 5.09755 8.50961C5.00055 8.49031 4.90002 8.50022 4.80866 8.53806C4.7173 8.5759 4.63921 8.63999 4.58427 8.72221C4.52932 8.80444 4.5 8.90111 4.5 9C4.5 9.13261 4.55268 9.25979 4.64645 9.35355C4.74021 9.44732 4.86739 9.5 5 9.5ZM7.5 9.5C7.59889 9.5 7.69556 9.47068 7.77779 9.41574C7.86001 9.36079 7.9241 9.2827 7.96194 9.19134C7.99978 9.09998 8.00969 8.99944 7.99039 8.90245C7.9711 8.80546 7.92348 8.71637 7.85355 8.64645C7.78363 8.57652 7.69454 8.5289 7.59755 8.50961C7.50056 8.49031 7.40002 8.50022 7.30866 8.53806C7.2173 8.5759 7.13921 8.63999 7.08426 8.72221C7.02932 8.80444 7 8.90111 7 9C7 9.13261 7.05268 9.25979 7.14645 9.35355C7.24021 9.44732 7.36739 9.5 7.5 9.5ZM7.5 7.5C7.59889 7.5 7.69556 7.47068 7.77779 7.41573C7.86001 7.36079 7.9241 7.2827 7.96194 7.19134C7.99978 7.09998 8.00969 6.99945 7.99039 6.90245C7.9711 6.80546 7.92348 6.71637 7.85355 6.64645C7.78363 6.57652 7.69454 6.5289 7.59755 6.50961C7.50056 6.49031 7.40002 6.50022 7.30866 6.53806C7.2173 6.5759 7.13921 6.63999 7.08426 6.72221C7.02932 6.80444 7 6.90111 7 7C7 7.13261 7.05268 7.25979 7.14645 7.35355C7.24021 7.44732 7.36739 7.5 7.5 7.5ZM5 7.5C5.09889 7.5 5.19556 7.47068 5.27779 7.41573C5.36001 7.36079 5.4241 7.2827 5.46194 7.19134C5.49978 7.09998 5.50969 6.99945 5.49039 6.90245C5.4711 6.80546 5.42348 6.71637 5.35355 6.64645C5.28363 6.57652 5.19454 6.5289 5.09755 6.50961C5.00055 6.49031 4.90002 6.50022 4.80866 6.53806C4.7173 6.5759 4.63921 6.63999 4.58427 6.72221C4.52932 6.80444 4.5 6.90111 4.5 7C4.5 7.13261 4.55268 7.25979 4.64645 7.35355C4.74021 7.44732 4.86739 7.5 5 7.5ZM8.5 1.5H8V1C8 0.867392 7.94732 0.740215 7.85355 0.646447C7.75979 0.552678 7.63261 0.5 7.5 0.5C7.36739 0.5 7.24021 0.552678 7.14645 0.646447C7.05268 0.740215 7 0.867392 7 1V1.5H3V1C3 0.867392 2.94732 0.740215 2.85355 0.646447C2.75979 0.552678 2.63261 0.5 2.5 0.5C2.36739 0.5 2.24021 0.552678 2.14645 0.646447C2.05268 0.740215 2 0.867392 2 1V1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V10C0 10.3978 0.158035 10.7794 0.43934 11.0607C0.720644 11.342 1.10218 11.5 1.5 11.5H8.5C8.89782 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.60218 9.84196 2.22064 9.56066 1.93934C9.27936 1.65804 8.89782 1.5 8.5 1.5ZM9 10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H1.5C1.36739 10.5 1.24021 10.4473 1.14645 10.3536C1.05268 10.2598 1 10.1326 1 10V5.5H9V10ZM9 4.5H1V3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H2V3C2 3.13261 2.05268 3.25979 2.14645 3.35355C2.24021 3.44732 2.36739 3.5 2.5 3.5C2.63261 3.5 2.75979 3.44732 2.85355 3.35355C2.94732 3.25979 3 3.13261 3 3V2.5H7V3C7 3.13261 7.05268 3.25979 7.14645 3.35355C7.24021 3.44732 7.36739 3.5 7.5 3.5C7.63261 3.5 7.75979 3.44732 7.85355 3.35355C7.94732 3.25979 8 3.13261 8 3V2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V4.5ZM2.5 7.5C2.59889 7.5 2.69556 7.47068 2.77779 7.41573C2.86001 7.36079 2.9241 7.2827 2.96194 7.19134C2.99978 7.09998 3.00969 6.99945 2.99039 6.90245C2.9711 6.80546 2.92348 6.71637 2.85355 6.64645C2.78363 6.57652 2.69454 6.5289 2.59755 6.50961C2.50055 6.49031 2.40002 6.50022 2.30866 6.53806C2.2173 6.5759 2.13921 6.63999 2.08427 6.72221C2.02932 6.80444 2 6.90111 2 7C2 7.13261 2.05268 7.25979 2.14645 7.35355C2.24021 7.44732 2.36739 7.5 2.5 7.5ZM2.5 9.5C2.59889 9.5 2.69556 9.47068 2.77779 9.41574C2.86001 9.36079 2.9241 9.2827 2.96194 9.19134C2.99978 9.09998 3.00969 8.99944 2.99039 8.90245C2.9711 8.80546 2.92348 8.71637 2.85355 8.64645C2.78363 8.57652 2.69454 8.5289 2.59755 8.50961C2.50055 8.49031 2.40002 8.50022 2.30866 8.53806C2.2173 8.5759 2.13921 8.63999 2.08427 8.72221C2.02932 8.80444 2 8.90111 2 9C2 9.13261 2.05268 9.25979 2.14645 9.35355C2.24021 9.44732 2.36739 9.5 2.5 9.5Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ getDuration() }}</span>
            </div>
          </div>
        </div>
        <div class="open-chat-att px-3" @click="handleClickConference">
          <div class="d-flex align-items-center">
            <div class="w-9 h-9 mx-2">
              <svg viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_123_32)">
                  <path
                    d="M118.945 103.132L77.7974 1.53337C76.9659 0.561005 75.7507 0 74.4715 0H15.2866C6.8651 0 0 6.87083 0 15.3178V234.682C0 243.129 6.8651 250 15.2866 250H80.7822C83.1914 250 85.1528 248.039 85.1528 245.624V229.911C85.1528 224.648 86.6026 219.509 89.3422 215.037L93.3824 203.401H82.6051C72.1689 203.401 62.9266 196.727 59.6219 186.795C57.3087 179.818 58.2361 176.28 62.1804 170.077C66.1139 163.88 72.5526 163.863 79.8441 163.025L98.0623 160.925L85.6433 125.759C84.9184 123.996 84.993 122.003 85.8458 120.299C86.7092 118.594 88.2657 117.349 90.1098 116.885L116.685 110.222C118.817 109.688 119.564 108.005 119.788 107.305C120.011 106.61 120.374 104.805 118.945 103.132Z"
                    fill="#20419B"
                  />
                  <path
                    d="M115.854 151.285C113.682 149.113 110.162 149.113 107.99 151.285C105.827 153.457 105.827 156.977 107.999 159.149C113.944 165.099 117.229 173.013 117.229 181.429C117.229 189.84 113.944 197.754 107.999 203.704C105.827 205.876 105.827 209.396 107.99 211.568C109.076 212.654 110.505 213.197 111.926 213.197C113.347 213.197 114.768 212.654 115.854 211.568C123.908 203.518 128.342 192.813 128.342 181.429C128.342 170.04 123.908 159.334 115.854 151.285Z"
                    fill="#20419B"
                  />
                  <path
                    d="M135.509 131.629C133.338 129.457 129.817 129.457 127.645 131.629C125.483 133.801 125.483 137.321 127.654 139.493C138.858 150.692 145.029 165.587 145.029 181.428C145.029 197.269 138.858 212.16 127.654 223.363C125.483 225.535 125.483 229.056 127.654 231.228C128.731 232.313 130.161 232.856 131.582 232.856C133.003 232.856 134.423 232.313 135.509 231.228C148.821 217.925 156.142 200.238 156.142 181.428C156.142 162.614 148.821 144.932 135.509 131.629Z"
                    fill="#20419B"
                  />
                  <path
                    d="M227.726 140.479H215.062V137.313C215.062 136.473 214.728 135.668 214.135 135.074C213.541 134.481 212.736 134.147 211.896 134.147C211.056 134.147 210.251 134.481 209.657 135.074C209.064 135.668 208.73 136.473 208.73 137.313V140.479H196.066C195.226 140.479 194.421 140.813 193.827 141.406C193.233 142 192.9 142.805 192.9 143.645C192.9 144.485 193.233 145.29 193.827 145.884C194.421 146.477 195.226 146.811 196.066 146.811H217.247C216.079 150.156 214.379 153.291 212.213 156.094C210.749 154.631 209.402 153.056 208.185 151.383C207.717 150.689 206.993 150.21 206.172 150.049C205.351 149.887 204.499 150.058 203.803 150.523C203.108 150.988 202.624 151.709 202.459 152.529C202.293 153.35 202.459 154.202 202.92 154.9C204.378 156.955 206.01 158.88 207.799 160.653C204.969 163.011 201.72 164.815 198.222 165.969C197.424 166.234 196.765 166.805 196.388 167.557C196.012 168.309 195.949 169.179 196.215 169.977C196.48 170.775 197.051 171.434 197.803 171.811C198.555 172.187 199.425 172.249 200.223 171.984C204.76 170.498 208.951 168.112 212.545 164.968C215.818 167.632 219.373 169.931 223.145 171.823C223.896 172.198 224.766 172.259 225.563 171.993C225.958 171.862 226.322 171.654 226.636 171.381C226.951 171.108 227.208 170.776 227.394 170.404C227.58 170.032 227.69 169.627 227.72 169.212C227.749 168.797 227.696 168.381 227.564 167.986C227.433 167.592 227.225 167.227 226.952 166.913C226.679 166.599 226.347 166.341 225.975 166.155C222.776 164.541 219.755 162.595 216.962 160.349C220.12 156.325 222.47 151.728 223.883 146.811H227.726C228.566 146.811 229.371 146.477 229.965 145.884C230.559 145.29 230.892 144.485 230.892 143.645C230.892 142.805 230.559 142 229.965 141.406C229.371 140.813 228.566 140.479 227.726 140.479Z"
                    fill="#20419B"
                  />
                  <path
                    d="M240.39 121.483H183.401C180.882 121.483 178.466 122.484 176.685 124.265C174.904 126.046 173.903 128.462 173.903 130.981V175.305C173.903 177.824 174.904 180.24 176.685 182.021C178.466 183.803 180.882 184.803 183.401 184.803H186.567V197.467C186.567 198.033 186.719 198.587 187.006 199.074C187.292 199.561 187.704 199.963 188.199 200.237C188.693 200.511 189.252 200.647 189.817 200.632C190.381 200.618 190.932 200.452 191.411 200.152L215.97 184.803H240.39C242.909 184.803 245.325 183.803 247.106 182.021C248.887 180.24 249.888 177.824 249.888 175.305V130.981C249.888 128.462 248.887 126.046 247.106 124.265C245.325 122.484 242.909 121.483 240.39 121.483ZM243.556 175.305C243.556 176.145 243.222 176.95 242.628 177.544C242.035 178.138 241.229 178.471 240.39 178.471H215.062C214.468 178.471 213.887 178.638 213.384 178.953L192.899 191.769V181.637C192.899 180.798 192.566 179.992 191.972 179.399C191.378 178.805 190.573 178.471 189.733 178.471H183.401C182.562 178.471 181.756 178.138 181.163 177.544C180.569 176.95 180.235 176.145 180.235 175.305V130.981C180.235 130.141 180.569 129.336 181.163 128.742C181.756 128.149 182.562 127.815 183.401 127.815H240.39C241.229 127.815 242.035 128.149 242.628 128.742C243.222 129.336 243.556 130.141 243.556 130.981V175.305Z"
                    fill="#20419B"
                  />
                  <path
                    d="M146.498 41.9097H203.487C206.006 41.9097 208.422 42.9104 210.203 44.6916C211.984 46.4728 212.985 48.8887 212.985 51.4077V95.732C212.985 98.2511 211.984 100.667 210.203 102.448C208.422 104.229 206.006 105.23 203.487 105.23H179.067L154.508 120.579C154.029 120.879 153.479 121.044 152.914 121.059C152.349 121.074 151.79 120.937 151.296 120.663C150.801 120.389 150.389 119.988 150.103 119.501C149.816 119.014 149.664 118.459 149.664 117.894V105.23H146.498C143.979 105.23 141.564 104.229 139.782 102.448C138.001 100.667 137 98.2511 137 95.732V51.4077C137 48.8887 138.001 46.4728 139.782 44.6916C141.564 42.9104 143.979 41.9097 146.498 41.9097ZM143.332 95.732C143.332 96.5717 143.666 97.377 144.26 97.9708C144.853 98.5645 145.659 98.8981 146.498 98.8981H152.83C153.67 98.8981 154.475 99.2316 155.069 99.8254C155.663 100.419 155.996 101.224 155.996 102.064V112.195L176.481 99.392C176.982 99.073 177.564 98.9018 178.159 98.8981H203.487C204.326 98.8981 205.132 98.5645 205.726 97.9708C206.319 97.377 206.653 96.5717 206.653 95.732V51.4077C206.653 50.5681 206.319 49.7628 205.726 49.169C205.132 48.5753 204.326 48.2417 203.487 48.2417H146.498C145.659 48.2417 144.853 48.5753 144.26 49.169C143.666 49.7628 143.332 50.5681 143.332 51.4077V95.732Z"
                    fill="#20419B"
                  />
                  <path
                    d="M177.841 56.3247C177.548 55.834 177.133 55.4277 176.637 55.1456C176.14 54.8634 175.578 54.7151 175.007 54.7151C174.436 54.7151 173.875 54.8634 173.378 55.1456C172.881 55.4277 172.466 55.834 172.174 56.3247L156.344 87.9849C156.158 88.357 156.047 88.7621 156.018 89.177C155.988 89.5919 156.041 90.0085 156.173 90.403C156.304 90.7976 156.513 91.1623 156.785 91.4764C157.058 91.7905 157.39 92.0478 157.762 92.2337C158.134 92.4195 158.539 92.5303 158.954 92.5596C159.369 92.5889 159.786 92.5362 160.18 92.4044C160.575 92.2727 160.939 92.0646 161.253 91.7919C161.568 91.5193 161.825 91.1874 162.011 90.8153L174.991 64.8191L180.95 76.736H174.991C174.152 76.736 173.346 77.0696 172.753 77.6633C172.159 78.2571 171.825 79.0623 171.825 79.902C171.825 80.7417 172.159 81.547 172.753 82.1407C173.346 82.7345 174.152 83.068 174.991 83.068H184.116L187.988 90.8153C188.174 91.1874 188.431 91.5193 188.745 91.7919C189.059 92.0646 189.424 92.2727 189.819 92.4044C190.213 92.5362 190.63 92.5889 191.045 92.5596C191.46 92.5303 191.865 92.4195 192.237 92.2337C192.609 92.0478 192.941 91.7905 193.213 91.4764C193.486 91.1623 193.694 90.7976 193.826 90.403C193.958 90.0085 194.01 89.5919 193.981 89.177C193.952 88.7621 193.841 88.357 193.655 87.9849L177.841 56.3247Z"
                    fill="#20419B"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_123_32">
                    <rect width="250" height="250" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <span
                class="block txt-black fs-16 fw-500"
              >{{ $t('circle_feature.lbl_circle_multi_lang_meet') }}</span>
            </div>
            <!-- <svg
              class="ml-2 mb-3"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10.5" cy="10.5" r="8.5" fill="#D92D20" stroke="#FEE4E2" stroke-width="4" />
            </svg>-->
          </div>
        </div>
      </div>

      <div v-if="sessionData.file_schedule&&sessionData.file_schedule.length" class="mt-4">
        <div
          v-for="file in sessionData.file_schedule"
          :key="file.id"
          class="flex mb-3 gap-2 items-center"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
              fill="#20409B"
            />
          </svg>
          <a :href="file.url" target="_blank" class="cs-link">{{ file.name }}</a>
        </div>
      </div>
      <div class="flex flex-col gap-2 mt-4">
        <div class="font-bold fs-18">{{ $t('conference.lbl_summary') }}</div>
        <pre>{{ getDataLang().abstract||'' }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import ImageBox from '@/components/Common/Image.vue'
import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'
import appUtils from '@/utils/appUtils'

export default {
  name: 'ConferenceSessionDetail',
  components: { ImageBox },
  data () {
    return {
      sessionData: {},
      isLoading: false,
      user_id: '',
      user_100ms_role: 'guest',
      selectedFeature: 'conference',
      circle: {},
      appUtils
    }
  },
  watch: {
    $route: {
      deep: true,
      handler () {
        this.getSessionDetail()
      }
    }
  },
  async created () {
    this.user_id = appUtils.getLocalUser().id
    await this.getSessionDetail()
    await this.showCircle()
    await this.get100msRole()
  },
  computed: {
    lang () {
      return LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
    }
  },
  methods: {
    async getSessionDetail () {
      if (!this.$route.params?.sessionId && !this.$route.query?.sessionId) {
        return
      }

      try {
        this.isLoading = true
        const response = await this.$rf
          .getRequest('ConferenceRequest')
          .getConferenceSessionDetail(
            this.$route.params?.sessionId || this.$route.query?.sessionId
          )
        this.sessionData = response.data.circle_session_data || {}
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    getHeader () {
      const langValue = LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
      const langData =
        this.sessionData?.circle_info?.circle_language?.find(
          item => item?.Lang === langValue
        ) || this.sessionData?.circle_info || {}
      return `${langData.name || ''}${langData.location ? ` (${langData.location})` : ''}`
    },
    getDataLang () {
      const langValue = this.lang
      const langData =
        this.sessionData?.pape_multilanguage?.find(
          item => item?.lang === langValue
        ) || {}
      return langData
    },
    getImageURL (avatar) {
      if (avatar.includes('https')) return avatar
      return appUtils.getImageURL(avatar)
    },
    goToProfile (data) {
      const doctorId = data?.doctor_infor?.id
      if (!doctorId) return
      this.$router
        .push({ name: 'DoctorProfile', params: { id: doctorId } })
        .catch(() => {})
    },
    displayDuration (totalMinutes) {
      return this.$t('conference.fm_minutes', { minutes: totalMinutes })
    },
    getDuration () {
      return window
        .moment(this.sessionData.schedule_date)
        .format('DD/MM/YYYY HH:mm')
    },
    async get100msRole () {
      const circle_id =
        Number(this.circle?.id) ||
        Number(this.$route.params?.id) ||
        Number(this.$route.query?.id)
      await this.$rf
        .getRequest('DoctorRequest')
        .checkMyRoleConferenceRoom({
          circle_id,
          user_id: this.user_id
        })
        .then(res => {
          this.user_100ms_role =
            res.data?.one_hundred_ms_role ||
            JSON.stringify({
              conference: 'guest',
              livestream: 'viewer'
            })
        })
        .catch(e => {
          console.log(e)
          this.$toast.open({
            message: e,
            type: 'error'
          })
        })
    },
    async handleClickConference () {
      if (!this.circle?.one_hundred_ms_conf_id) return ''

      const { id, one_hundred_ms_conf_id } = this.circle
      await this.get100msRole().then(() => {
        let token = appUtils.getLocalToken()
        let dm = ''
        if (process.env.NODE_ENV === 'development') {
          dm = 'https://dev.live.hodo.app'
        } else {
          dm = 'https://live.hodo.app'
        }

        const roleObj = appUtils.isJSON(this.user_100ms_role)
          ? JSON.parse(this.user_100ms_role)
          : {
            [this.selectedFeature]: this.user_100ms_role
          }
        const role = roleObj[this.selectedFeature]
        const routeRaw = `${dm}/redirect.html?token=${token}&room_id=${one_hundred_ms_conf_id}&circle_id=${id}&type=conference&role=${role ||
          'guest'}&lang=${this.$lang}`

        setTimeout(() => {
          window.open(
            routeRaw,
            // !appUtils.checkIsMobile() &&
            '_blank',
            'noopener noreferrer'
          )
        })
      })
    },
    async showCircle () {
      let self = this
      if (!this.$route.params.id) return
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircle(this.$route.params.id)
        .then(r => {
          self.circle = { ...r.data }

          return r
        })
        .catch(e => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          self.$router.push({ name: 'WorkspaceConference' }).catch(() => {})
          return false
        })
      return r?.data
    },
    getStatus (status) {
      switch (status) {
        case 1:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
        case 2:
          return {
            text: this.$t('circle_feature.lbl_public_schedule'),
            class: 'public'
          }
        case 3:
          return {
            text: this.$t('circle_feature.lbl_live_now'),
            class: 'ongoing'
          }
        default:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
      }
    },
    goToCircleDetail () {
      if (!this.$route.params?.id && !this.$route.query?.id) return

      this.$router.go(-1)
      // this.$router
      //   .replace({
      //     name: 'WorkspaceConferenceDetail',
      //     params: {
      //       id: this.$route.params?.id || this.$route.query?.id
      //     }
      //   })
      //   .catch(() => {})
    },
    getMultilangValue (data) {
      return data?.find(item => (item?.Lang || item?.lang) === this.lang) || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.open-chat-att {
  display: flex;
  align-items: center;
  background-color: #fafafa;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 16px;
  position: relative;
  transition: all 0.3s ease;
  max-height: 60px;

  &:hover {
    background-color: #eff4ff;
  }
}

.cs-live {
  border: 3px solid #f04438;
  border-radius: 16px;
  padding: 6px;
  max-width: 140px;
  color: #f04438;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs-link {
  text-decoration: underline;
  color: #20409b;
}

.title {
  &.labels {
    line-height: 21px;
  }
  span {
    display: inline-block;
    text-wrap: nowrap;
    border-radius: 15px;
    padding: 2px 10px;
  }
  .draft {
    background-color: rgb(0, 195, 255);
  }
  .public {
    background-color: #00b135;
  }
  .ongoing {
    background-color: red;
  }
}

pre {
  background: transparent;
  border: unset;
}
</style>
